import React from 'react';
function addSettingsMenuItem(menuItems, config, isEnabled = config.hasSettingsAccess && config.domain === 'empresa') {
    if (!isEnabled)
        return;
    menuItems.push({
        label: config.translate('settings.menu.label'),
        icon: React.createElement(config.IconComponent, { name: 'config' }),
        path: '/configuracoes',
    });
}
function addCadastrosMenuItem(menuItems, config, isEnabled = config.hasCadastrosAccess && config.domain === 'empresa') {
    if (!isEnabled)
        return;
    menuItems.push({
        label: config.translate('cadastros.menu.label'),
        icon: React.createElement(config.IconComponent, { name: 'database' }),
        path: '/cadastros',
    });
}
function addNotasFiscaisMenuItem(menuItems, config) {
    if (config.hasNotasFiscaisAccess && config.domain === 'empresa') {
        menuItems.push({
            label: config.translate('notasFiscaisErp.menu.label'),
            icon: React.createElement(config.IconComponent, { name: 'fileInvoiceIssued' }),
            path: '/notas-fiscais-erp',
        });
    }
}
function addVendasMenuItem(menuItems, config) {
    if (config.hasVendasAccess && config.domain === 'empresa') {
        menuItems.push({
            label: config.translate('vendas.menu.label'),
            icon: React.createElement(config.IconComponent, { name: 'cart' }),
            path: '/vendas',
        });
    }
}
function addFinanceiroMenuItem(menuItems, config, isEnabled = config.hasFinanceiroAccess && config.domain === 'empresa') {
    if (!isEnabled)
        return;
    menuItems.push({
        label: config.translate('financeiro.menu.label'),
        icon: React.createElement(config.IconComponent, { name: 'sackDollar' }),
        path: '/financeiro',
    });
}
function addErpMenuItems(menuItems, config) {
    if (!config.hasErpSettingsAccess)
        return;
    addSettingsMenuItem(menuItems, config, true);
    addCadastrosMenuItem(menuItems, config, true);
    menuItems.push({
        label: config.translate('vendas.menu.label'),
        icon: React.createElement(config.IconComponent, { name: 'cart' }),
        path: '/vendas/servico',
        children: [
            {
                label: config.translate('vendas.submenu.servicos'),
                path: '/vendas/servico',
            },
            {
                label: config.translate('vendas.submenu.produtos'),
                path: '/vendas/produtos',
                disabled: true,
            },
        ],
    });
    addFinanceiroMenuItem(menuItems, config, true);
}
function addNavigationMenuItems(menuItems, config) {
    if (config.hasErpSettingsAccess === undefined) {
        addCadastrosMenuItem(menuItems, config);
        addVendasMenuItem(menuItems, config);
        addFinanceiroMenuItem(menuItems, config);
        addNotasFiscaisMenuItem(menuItems, config);
        addSettingsMenuItem(menuItems, config);
        return;
    }
    addErpMenuItems(menuItems, config);
}
function isLegacyMenuItemVisible(isEnabled, hasErpSettingsAccess) {
    return Boolean(isEnabled) && !hasErpSettingsAccess;
}
const ERP_EMPRESA_MENU_ORDER = [
    '/home',
    '/conta-pj',
    '/vendas/servico',
    '/credito-pj',
    '/financeiro',
    '/contabilidade-digital',
    '/cadastros',
    '/configuracoes',
];
function reorderErpEmpresaMenuItems(menuItems, config) {
    if (!config.hasErpSettingsAccess || config.domain !== 'empresa')
        return;
    const orderByPath = new Map(ERP_EMPRESA_MENU_ORDER.map((path, index) => [path, index]));
    const targetPositions = menuItems
        .map((item, index) => (orderByPath.has(item.path) ? index : -1))
        .filter(index => index >= 0);
    const orderedItems = targetPositions
        .map(index => menuItems[index])
        .sort((first, second) => (orderByPath.get(first.path) ?? 0) - (orderByPath.get(second.path) ?? 0));
    targetPositions.forEach((position, index) => {
        menuItems[position] = orderedItems[index];
    });
}
export function generateMenuItems(config) {
    const { hasBillingAccess, hasMyClientsAccess, hasNFSeMenuAccess, supportMenuItem, IconComponent, ProductStatus, hasAccountPjAccess, hasDigitalAccountingAccess, hasClientPortalViewPermission, hasBenefitAccess, hasCreditoPjAccess, hasLoyaltyProgramAccess, hasTwoOrMoreAccesses, translate, onLoyaltyProgramMenuClick, } = config;
    const hasErpSettingsAccess = config.hasErpSettingsAccess === true;
    const menuItems = [];
    if (hasTwoOrMoreAccesses) {
        menuItems.push({
            label: 'Visão geral',
            icon: React.createElement(IconComponent, { name: 'home' }),
            path: '/home',
        });
    }
    if (hasAccountPjAccess) {
        menuItems.push({
            label: translate('products.conta-pj'),
            icon: React.createElement(IconComponent, { name: 'digitalAccount' }),
            path: '/conta-pj',
        });
    }
    if (isLegacyMenuItemVisible(hasBillingAccess, hasErpSettingsAccess)) {
        menuItems.push({
            label: 'Cobranças',
            icon: React.createElement(IconComponent, { name: 'handHoldingDollar' }),
            path: '/cobrancas',
            status: ProductStatus.ACTIVE,
        });
    }
    if (isLegacyMenuItemVisible(hasNFSeMenuAccess, hasErpSettingsAccess)) {
        menuItems.push({
            label: 'Notas fiscais',
            icon: React.createElement(IconComponent, { name: 'fileInvoiceIssued' }),
            path: '/notas-fiscais',
        });
    }
    if (hasBenefitAccess) {
        menuItems.push({
            label: 'Benefícios',
            icon: React.createElement(IconComponent, { name: 'faceSmileWinkl' }),
            path: '/beneficios',
        });
    }
    if (hasAccountPjAccess) {
        menuItems.push({
            label: 'Pagamentos',
            icon: React.createElement(IconComponent, { name: 'fileInvoiceDollar' }),
            path: '/pagamentos',
        });
    }
    if (hasClientPortalViewPermission || hasDigitalAccountingAccess) {
        menuItems.push({
            label: translate('products.contabilidade-digital'),
            icon: React.createElement(IconComponent, { name: 'content' }),
            path: '/contabilidade-digital',
        });
    }
    if (hasLoyaltyProgramAccess && config.domain === 'escritorio') {
        menuItems.push({
            label: translate('products.programa-fidelidade'),
            icon: React.createElement(IconComponent, { name: 'coinsDollar' }),
            path: '/dominio-recompensas',
            ...(onLoyaltyProgramMenuClick ? { onClick: onLoyaltyProgramMenuClick } : {}),
        });
    }
    if (hasCreditoPjAccess && config.domain === 'empresa') {
        menuItems.push({
            label: 'Crédito PJ',
            icon: React.createElement(IconComponent, { name: 'envelopeOpenDollar' }),
            path: '/credito-pj',
        });
    }
    if (isLegacyMenuItemVisible(hasMyClientsAccess, hasErpSettingsAccess)) {
        menuItems.push({
            label: translate('products.my-clients'),
            icon: React.createElement(IconComponent, { name: 'doubleUsers' }),
            path: '/meus-clientes',
        });
    }
    addNavigationMenuItems(menuItems, config);
    reorderErpEmpresaMenuItems(menuItems, config);
    menuItems.push(supportMenuItem);
    return menuItems;
}
